import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Store } from '@ngrx/store';
import { TeamState } from '../../store/team/team.reducer';
import * as fromTeamSelector from '../../store/team/team.selectors';
import { Observable, Subject, Subscription } from 'rxjs';
import { TeamMaxPerTime, PerDaySlotsForCustomData, ShopMaxPerDay, SlotsPerDay, MasterSlot } from '../../shared/models/slot-management.model';
import { LoadTeams } from '../../store/team/team.actions';
import { SlotState } from '../../store/slot/slot.reducer';
import * as fromActions from '../../store/slot/slot.actions';
import * as fromSelector from '../../store/slot/slot.selectors';
import { Department, ITeam } from '@signal/asp-data-commons';
import { EmployeeState } from '../../store/employee/employee.reducer';
import { LoadEmployees } from '../../store/employee/employee.actions';
import { INavigateAway } from '../../shared/guards/NavigationGuard';
import { ConfirmDialogComponent } from '../../shared/components/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { exitConfig } from '../../shared/services/util.service';

@Component({
  selector: 'app-dealership-capacity',
  templateUrl: './dealership-capacity.component.html',
  styleUrls: ['./dealership-capacity.component.scss']
})
export class DealershipCapacityComponent implements OnInit, OnDestroy,INavigateAway {
  teams$: Observable<ITeam[]>;
  viewMode = 'Shop';
  subscriptions: Subscription[] = [];

  teamMaxTotal$: Observable<PerDaySlotsForCustomData[]>;
  // technicianMaxTotal$: Observable<PerDaySlotsForCustomData[]>;
  transportMaxTotal$: Observable<ShopMaxPerDay[]>;
  slotDetails$: Observable<SlotsPerDay[]>;
  maxAndMasterSlots$: Observable<{ max: any, masterSlot: MasterSlot[] }>;

  teamIndicator$: Observable<any>;
  teamActivate: {}
  technicianIndicator$: Observable<any>;
  technicianActivate: {}
  transportIndicator$: Observable<any>;
  transportActivate: {}
 teamSlotsDetails: TeamMaxPerTime[];
  department = Department.SERVICE;
  selectedTeam: ITeam;
  masterSlotsLoading$: Observable<boolean>;
  tableValueInfo = [
    {value : 'departmentCapacity.blank', description : 'departmentCapacity.notLimitedToANumberOfAppointmentsForTheTimePeriod'},
    {value : '0', description : 'departmentCapacity.blocksTheTimePeriod'},
    {value : 'departmentCapacity.numericValue', description : 'departmentCapacity.setsANumberOfAppointmentsForTheTimePeriod'}];

  //save clicked 
  isShopMaxPerTimeDaySaveClicked=false
  isSavedClicked=false;
  isTeamMaxPerTimeDaySaveClicked=false

  //cancel clicked
  isCancelClicked=false;
  isShopMaxSlotsPerTimePeriodCancleClicked=false
  isTeamMaxSlotsPerTimePeriodCancleClicked=false

 //forms edited
  isShopMaxSlotsPerDayEdited=false;
  isTeamMaxSlotsPerTimePeriodEdited=false;
  isShopMaxSlotsPerTimePeriodEdited=false;
  allFormsEdited=false;

  shopSlotsUpdated$:Observable<boolean>;
  teamSlotsUpdated$:Observable<boolean>;

  constructor(
    private readonly teamState: Store<TeamState>,
    private readonly slotState: Store<SlotState>,
    private readonly employeeState: Store<EmployeeState>,
    private readonly cdr: ChangeDetectorRef,
    private readonly dialog: MatDialog,
    ) {
    }

  ngOnInit() { 
    this.teamState.dispatch(new LoadTeams());
    // this.employeeState.dispatch(new LoadEmployees());
    this.teams$ = this.teamState.select(fromTeamSelector.selectNonTxmTeams);
    this.shopSlotsUpdated$ = this.slotState.select(fromSelector.selectShopSlotsUpdated);
    this.teamSlotsUpdated$ = this.slotState.select(fromSelector.selecTeamSlotsUpdated);
    
    this.slotState.dispatch(new fromActions.LoadMasterSlots());

    this.loadView(this.viewMode);

    this.slotState.dispatch(new fromActions.LoadActivateIndicators());
    // this.slotState.dispatch(new fromActions.LoadTechnicianActivateIndicators());
    this.teamIndicator$ = this.slotState.select(fromSelector.selectActivateIndicators);
    this.subscriptions.push(this.teamIndicator$.subscribe(ActivateIndicator => {
      this.teamActivate = ActivateIndicator['indicator'];
    })
    );
    // this.technicianIndicator$ = this.slotState.select(fromSelector.selectTechnicianActivateIndicators);
    // this.technicianIndicator$.subscribe(ActivateIndicator => {
    //   this.technicianActivate = ActivateIndicator['indicator'];
    // })
  }

  //checks if navigation is allowed 
  canExit():Observable<boolean> { 
    const result = new Subject<boolean>();
    const dialogRef = this.dialog.open(ConfirmDialogComponent,exitConfig
      );
    this.subscriptions.push(dialogRef.afterClosed().subscribe(event => {
      if (event.action === 'confirm') {
        this.onSaveClicked();
        if(this.viewMode=='Shop')
        {
          this.subscriptions.push(this.shopSlotsUpdated$.subscribe(data=>{
            if(data)
            {
              result.next(true);
              result.complete();
            }
          }))
        }else{
          this.subscriptions.push(this.teamSlotsUpdated$.subscribe(data=>{
            if(data)
            {
              result.next(true);
              result.complete();
            }
          }));
        }
    }
      else if(event.action === 'close'){
        this.onCancelClicked();
        result.next(true);
        result.complete();
      }
    }));
    return result.asObservable(); 
  };

  //show alert when switching to another tab if unsaved changes
  showAlert(mode)
  {
    const dialogRef = this.dialog.open(ConfirmDialogComponent,exitConfig);
    this.subscriptions.push(dialogRef.afterClosed().subscribe(event => {
      if (event.action === 'confirm') {
        this.onSaveClicked();
        if(this.viewMode=='Shop')
        {
          this.subscriptions.push(this.shopSlotsUpdated$.subscribe(data=>{
            if(data)
            {
              this.loadView(mode);  
            }
          }));
        }else{
          this.subscriptions.push(this.teamSlotsUpdated$.subscribe(teamSlotData=> {
            if(teamSlotData)
            {
              this.loadView(mode);  
            }
          }));
        }
      }
      else if(event.action === 'close'){
        this.onCancelClicked();
        this.loadView(mode);    
      }
      else{}
    }));
  }
  
  ngAfterContentChecked(): void { 
    if (!this.cdr['destroyed']) {
      this.cdr.detectChanges();
    }
  }

  loadView(mode){
    this.viewMode = mode;
    if (this.viewMode == 'Shop') {
    this.slotState.dispatch(new fromActions.LoadShopMaxTotal());
    this.slotState.dispatch(new fromActions.LoadShopMaxSlots());
    this.slotDetails$ = this.slotState.select(fromSelector.selectShopMaxSlots);

    } else if (this.viewMode == 'Team') {
      this.slotState.dispatch(new fromActions.LoadTeamMaxTotal());
      this.slotState.dispatch(new fromActions.LoadTeamMaxSlots());
      this.teamMaxTotal$ = this.slotState.select(fromSelector.selectTeamMaxTotal);
    }
    // else if (this.viewMode == 'Technician') {
    //   this.slotState.dispatch(new fromActions.LoadTechnicianMaxTotal());
    //   this.slotState.dispatch(new fromActions.LoadTechnicianMaxSlots());
    //   this.technicianMaxTotal$ = this.slotState.select(fromSelector.selectTechnicianMaxTotal);
    // }

    this.maxAndMasterSlots$ = this.slotState.select(fromSelector.selectMaxAndMasterSlots, {view: this.viewMode});
    this.masterSlotsLoading$ = this.slotState.select(fromSelector.selectMasterSlotsLoading);
  }

  updateSwitchValues(val: boolean, property: string) {
    switch (property) {
      case 'team':
        this.teamActivate = val;
        this.slotState.dispatch(new fromActions.UpdateActivateIndicators({ indicator : val }))
        break;
      // case 'technician':
      //   this.technicianActivate = val;
      //   this.slotState.dispatch(new fromActions.UpdateTechnicianActivateIndicators({ indicator : val }))
      //   break;

        default:
          break;
      }
  }

  getTeamSlotDetails(team: ITeam){
    this.slotDetails$ = this.slotState.select(fromSelector.selectTeamMaxSlotsForTeamId, { teamId: team.id });
    return this.slotDetails$;
  }

  onSaveChanges(slotDetails) {
    if (this.viewMode == 'Shop') {
      this.slotState.dispatch(
        new fromActions.UpdateShopMaxSlots({ shopMaxSlots: slotDetails,bothFormsEdited:this.allFormsEdited }));   
    } else {
      this.slotState.dispatch(new fromActions.UpdateTeamMaxSlots(
        {
          teamMaxSlots: {
            slotsPerDay: slotDetails,
            teamId: this.selectedTeam.id
          },
          allFormsEdited:false
        }));    
    }
    this.isSavedClicked=false
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
    this.cdr.detach();
  }

  // returns if the forms are not edited
  formsNotEdited()
  {
    return !this.isShopMaxSlotsPerDayEdited && !this.isShopMaxSlotsPerTimePeriodEdited &&!this.isTeamMaxSlotsPerTimePeriodEdited;
  }

  // returns if the forms are not edited
  formsEdited()
  {
    return this.isShopMaxSlotsPerDayEdited || this.isShopMaxSlotsPerTimePeriodEdited ||this.isTeamMaxSlotsPerTimePeriodEdited;
  }

  //save button clicked
  onSaveClicked()
  {
    this.isShopMaxPerTimeDaySaveClicked=this.isShopMaxSlotsPerDayEdited?true:false
    this.isTeamMaxPerTimeDaySaveClicked=this.isTeamMaxSlotsPerTimePeriodEdited?true:false
    this.isSavedClicked=this.isShopMaxSlotsPerTimePeriodEdited?true:false
    this.allFormsEdited=(this.isShopMaxSlotsPerDayEdited && this.isShopMaxSlotsPerTimePeriodEdited) && this.isShopMaxSlotsPerTimePeriodEdited?true:false
    // detect changes after manually calling onCanclelicked()
    if (!this.cdr['destroyed']) {
      this.cdr.detectChanges();
    }
  }

  //cancel button clicked 
  onCancelClicked()
  {
    this.isCancelClicked=this.isShopMaxSlotsPerDayEdited?true:false
    this.isShopMaxSlotsPerTimePeriodCancleClicked=this.isShopMaxSlotsPerTimePeriodEdited?true:false
    this.isTeamMaxSlotsPerTimePeriodCancleClicked=this.isTeamMaxSlotsPerTimePeriodEdited?true:false
     // detect changes after manually calling onCanclelicked()
     if (!this.cdr['destroyed']) {
      this.cdr.detectChanges();
    }
  }

  //reset cancle button clicked value for 1st form
  resetCancleClickValue(event)
  {
    this.isCancelClicked=event
    this.isShopMaxSlotsPerDayEdited=event
  }

  //reset cancle button clicked value for 2nd form
  resetCancleClickedPerTimePeriod(event)
  {
    this.isShopMaxSlotsPerTimePeriodCancleClicked=event
    this.isShopMaxSlotsPerTimePeriodEdited=event
  }

  //reset cancel button for team max slots form
  resetCancleClickedTeamPerTimePeriod(event)
  {
    this.isTeamMaxSlotsPerTimePeriodCancleClicked=event
    this.isTeamMaxSlotsPerTimePeriodEdited=event
  }

  //reset save button value cliked from 1st from
  resetSaveClickedValue(event)
  {
    this.isShopMaxPerTimeDaySaveClicked=event
  }

  //Appointment per day form edited 
  shopMaxSlotsPerDayFormEdited(event)
  {
    this.isShopMaxSlotsPerDayEdited=event
  }

   //Appointment per time period form edited 
   shopMaxSlotsPerTimeTableFormEdited(event)
   {
     this.isShopMaxSlotsPerTimePeriodEdited=event
   }

    // form team max slots edited
    teamMaxSlotsPerDayEdited(event)
    {
      this.isTeamMaxSlotsPerTimePeriodEdited=event
    }

    //reset save button for team max slots form
    teamMaxSlotsPerDaySaveReset(event)
    {
      this.isTeamMaxPerTimeDaySaveClicked=event
      if (!this.cdr['destroyed']) {
        this.cdr.detectChanges();
      }
    }


}
